/* The reversed (white) lockup - the only variant the product UI needs so
 * far, since both places it appears (the app shell header, the sign-in
 * panel) sit on ink (23-brand-guidelines.md section 2: "reversed logo on
 * backgrounds darker than #5A6B78"). Width is left to the browser - the SVG
 * carries its own viewBox aspect ratio (2100:432), and the brand guide
 * forbids stretching it off that ratio.
 */
export function Logo({ height = 22 }: { height?: number }) {
  return <img src="/logo/arborcision-logo-white.svg" alt="Arborcision" height={height} />;
}
